var account = "Konto";
var accountSettings = "Kontoinnstillinger";
var charging = "Lading";
var contactInfo = "Kontaktinfo";
var dashboard = "Dashboard";
var home = "Startside";
var myProducts = "Mine produkter";
var orderHistory = "Bestillingshistorikk";
var paymentMethod = "Betalingsmåte";
var profileSettings = "Profilinnstillinger";
var referAndEarn = "Henvis og tjen";
var signOut = "Logg av";
var no_NO = {
	account: account,
	accountSettings: accountSettings,
	charging: charging,
	contactInfo: contactInfo,
	dashboard: dashboard,
	home: home,
	myProducts: myProducts,
	orderHistory: orderHistory,
	paymentMethod: paymentMethod,
	profileSettings: profileSettings,
	referAndEarn: referAndEarn,
	signOut: signOut
};

export { account, accountSettings, charging, contactInfo, dashboard, no_NO as default, home, myProducts, orderHistory, paymentMethod, profileSettings, referAndEarn, signOut };
